//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.Feature.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"AllowDeleteMembers",1,0]],[[["createdPart"],"CreateLinkedPartModule",{R_:{linkedPartModule:"Features.Feature"}},1,0],[[],"CreatePartModuleOutputBuilder",{R_:{builder:"GeometricUtilities.PartModuleOutputBuilder"}},0,1],[[],"ShowOnly",{},0,0],[[],"UpdateInputReferences",{},0,0],[[],"LoadInterpartData",{},0,0],[[],"UpdateOutputReferences",{},0,0],[["active"],"Activate",{},1,0],[[],"MakeLinkedWork",{},0,1],[[],"MakeMainWork",{},0,1],[[],"Merge",{},0,0],[[],"BreakRelationship",{},0,0],[[],"CreatePartModuleInputBuilder",{R_:{builder:"GeometricUtilities.PartModuleInputBuilder"}},0,0],[[],"CreatePartModuleOutputBuilder1",{R_:{builder:"GeometricUtilities.PartModuleOutputBuilder1"}},0,0],[[],"ProcessDeletePartModule",{},0,0],[[],"DisplayMainPart",{},0,0],[[],"DisplayLinkedPart",{},0,0],[["partLoadOption"],"LoadPartWithOption",{R_:{newPartTag:"Part"}},1,0],[[],"DisplayMainPartInNewWindow",{},0,0],[[],"DisplayLinkedPartInNewWindow",{},0,0]],[]];
SPLM.Features.PartModule = class extends SPLM.Features.Feature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.PartModule";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.PartModule.PartLoadOption = Object.freeze({
    "DontAllowSave" : "DontAllowSave", "LoadInterpart" : "LoadInterpart"});

export default SPLM;